import { render, staticRenderFns } from "./DoneСonsumptionModal.vue?vue&type=template&id=c764d7b2"
import script from "./DoneСonsumptionModal.vue?vue&type=script&lang=js"
export * from "./DoneСonsumptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports